/* eslint-disable react-hooks/exhaustive-deps */
import { useSearchParams, useNavigate } from "react-router-dom";
import { ShopContext } from "../Context/ShopContext";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import images from "../../assets/images/assets";

const Verify = () => {
  const { token, setCartItems, backendUrl } = useContext(ShopContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState("loading"); // loading, success, error

  const success = searchParams.get("success");
  const orderId = searchParams.get("orderId");

  const verifyPayment = async () => {
    try {
      if (!token) {
        return null;
      }

      console.log(token);
      const response = await axios.post(
        backendUrl + "/api/order/verify-stripe",
        { success, orderId },
        {
          headers: {
            Authorization: `Bearer ${token}`, // added bearer prefix
          },
        }
      );

      console.log(response.data);

      if (response.data.success) {
        setCartItems({});
        setVerificationStatus("success");
      } else {
        setVerificationStatus("error");
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
      setVerificationStatus("error");
    }
  };

  useEffect(() => {
    verifyPayment();
  }, [token]);

  useEffect(() => {
    if (verificationStatus === "success") {
      setTimeout(() => navigate("/orders"), 3000); // Redirect after 3 seconds
    } else if (verificationStatus === "error") {
      setTimeout(() => navigate("/cart"), 3000); // Redirect after 3 seconds
    }
  }, [verificationStatus, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md text-center">
        <img
          src={images.stripe_logo}
          alt="stripe logo"
          className="w-20 lg:w-22 mx-auto mb-6 animate-pulse" // Added pulse animation
        />

        {verificationStatus === "loading" && (
          <div className="space-y-4">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-indigo-500 mx-auto"></div>
            <p className="text-gray-600">Verifying payment...</p>
          </div>
        )}

        {verificationStatus === "success" && (
          <div className="space-y-4">
            <img
              src={images.success_icon} // Replace with your success icon
              alt="success icon"
              className="w-20 mx-auto animate-bounce" // Added bounce animation
            />
            <h2 className="text-2xl font-semibold text-green-600">
              Payment Verified!
            </h2>
            <p className="text-gray-600">
              Your payment was successful. Redirecting to orders...
            </p>
          </div>
        )}

        {verificationStatus === "error" && (
          <div className="space-y-4">
            <img
              src={images.error_icon} // Replace with your error icon
              alt="error icon"
              className="w-20 mx-auto animate-shake" // Added shake animation
            />
            <h2 className="text-2xl font-semibold text-red-600">
              Payment Failed
            </h2>
            <p className="text-gray-600">
              There was an error verifying your payment. Redirecting to cart...
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Verify;
